import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import RecentUsersTableContainer from './RecentUsersTableContainer';
import classes from '../index.module.scss';
import { usersSearchPost } from '../../../api';

const RECENT_USERS_HEADER_LIST = [
  'Type',
  'User Name',
  'Date',
  'Action'
];

const RecentRegistrations = ({ setLoading, handleDefaultStatusCodes }) => {
  const [users, setUsers] = useState([]);
  const [searchTrigger, setSearchTrigger] = useState(false);

  useEffect(() => {
    usersSearchPost({
      limit: 10,
      order_by: ["registration_date|desc"],
      select: [
        "role_description",
        "username",
        "registration_date",
        "id"
      ]
    }, {})
      .then(response => {
        setUsers(response.data.results);
      })
      .catch(error => {
        handleDefaultStatusCodes();
      })
  }, [searchTrigger]);

  return (
    <div>
      <div className={`d-flex align-items-center justify-content-between mb-5 ${classes.Custom_Min_Height}`}>
        <h5 className="mb-0">Last 10 Registrations</h5>
        <Link
          to="/users"
          className="btnSizes transparentBtn"
        >
          All Users
        </Link>
      </div>
      <RecentUsersTableContainer 
        users={users} 
        header_list={RECENT_USERS_HEADER_LIST} 
        searchTrigger={searchTrigger} 
        setSearchTrigger={setSearchTrigger}
      />
    </div>
  )
}

export default RecentRegistrations;